const global = window

inputs.types.file = function (data, name, niceName, type, input, parent, inputWindow) {
    console.log("[File Field] Initializing field:", name, { data, type, input, parent });

    var dropzone = input.closest('.file-dropzone');
    if (!dropzone.length) {
        console.warn("[File Field] Dropzone element not found for field:", name);
        return data;
    }

    var filename = dropzone.find('.file-dropzone__filename');
    var badge = dropzone.find('.file-dropzone__badge');
    var filesize = dropzone.find('.file-dropzone__filesize');
    var deleteInput = dropzone.find('.file-dropzone__delete-input');
    var preview = dropzone.find('.file-dropzone__preview');
    var docIcon = dropzone.find('.file-dropzone__doc-icon');
    var viewBtn = dropzone.find('.file-dropzone__btn--view');

    function formatBytes(bytes, decimals = 1) {
        if (!bytes || bytes === 0) return '0 o';
        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ['o', 'Ko', 'Mo', 'Go'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }

    // --- Clic sur la boîte de prévisualisation ou sur le bouton remplacer ---
    dropzone.on("click", ".file-dropzone__preview-box, .file-dropzone__btn--replace", function(e) {
        e.preventDefault();
        e.stopPropagation();
        if (input[0]) {
            input[0].click();
        }
    });

    // --- Sélection via l'input natif ---
    input.on("change", function() {
        var files = this.files;
        console.log("[File Field] Input change triggered. Files selected:", files ? files.length : 0);
        if (files && files.length > 0) {
            if (deleteInput.length) {
                deleteInput.val('0');
                console.log("[File Field] Reset delete status to 0");
            }
            showFile(files[0]);
        }
    });

    // --- Prévenir le comportement par défaut de l'ouverture du fichier sur la fenêtre globale ---
    var preventDefault = function(e) {
        if (e.originalEvent.dataTransfer && e.originalEvent.dataTransfer.types && Array.from(e.originalEvent.dataTransfer.types).includes('Files')) {
            e.preventDefault();
        }
    };
    $(window).on("dragover drop", preventDefault);

    // --- Drag & drop sur la dropzone ---
    dropzone.on("dragenter dragover", function(e) {
        e.preventDefault();
        e.stopPropagation();
        dropzone.addClass("dragover");
    });

    dropzone.on("dragleave", function(e) {
        e.preventDefault();
        e.stopPropagation();
        if (!dropzone[0].contains(e.originalEvent.relatedTarget)) {
            dropzone.removeClass("dragover");
        }
    });

    dropzone.on("drop", function(e) {
        e.preventDefault();
        e.stopPropagation();
        dropzone.removeClass("dragover");

        var files = e.originalEvent.dataTransfer ? e.originalEvent.dataTransfer.files : null;
        console.log("[File Field] File dropped. Files count:", files ? files.length : 0);
        if (files && files.length > 0) {
            if (deleteInput.length) {
                deleteInput.val('0');
                console.log("[File Field] Reset delete status to 0");
            }
            // Injecter les fichiers droppés dans l'input natif
            try {
                var dt = new DataTransfer();
                for (var i = 0; i < files.length; i++) dt.items.add(files[i]);
                input[0].files = dt.files;
                console.log("[File Field] Injected files into native file input");
            } catch (ex) {
                console.error("[File Field] Failed to inject files using DataTransfer:", ex);
            }
            showFile(files[0]);
        }
    });

    // --- Bouton Supprimer ---
    dropzone.on("click", ".file-dropzone__btn--remove", function(e) {
        console.log("[File Field] Remove button clicked");
        e.preventDefault();
        e.stopPropagation();

        // Vider l'input de fichier
        input.val('');

        // Signaler la suppression au backend
        if (deleteInput.length) {
            deleteInput.val('1');
            console.log("[File Field] Set delete status to 1");
        }

        // Mettre à jour l'interface
        dropzone.removeClass("has-file is-image");
        if (filename.length) {
            filename.text('').removeAttr('title');
        }
        if (badge.length) {
            badge.text('FICHIER');
        }
        if (filesize.length) {
            filesize.text('');
        }
        if (preview.length) {
            preview.empty();
        }
        if (docIcon.length) {
            docIcon.addClass('hidden');
        }
        if (viewBtn.length) {
            viewBtn.hide();
        }
    });

    function showFile(file) {
        console.log("[File Field] Previewing file:", file.name, "Type:", file.type, "Size:", file.size);
        var name = file.name || '';
        var ext = name.split('.').pop().toLowerCase();
        var isImage = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg', 'avif'].includes(ext) || (file.type && file.type.startsWith('image/'));

        dropzone.addClass("has-file");
        if (isImage) {
            dropzone.addClass("is-image");
        } else {
            dropzone.removeClass("is-image");
        }

        // Métadonnées
        if (filename.length) {
            filename.text(name).attr('title', name);
        }
        if (badge.length) {
            badge.text((ext || 'FICHIER').toUpperCase());
        }
        if (filesize.length) {
            filesize.text(formatBytes(file.size) + ' • Nouveau fichier');
        }

        // Le bouton "ouvrir l'original" concerne le fichier enregistré sur le serveur
        if (viewBtn.length) {
            viewBtn.hide();
        }

        if (isImage) {
            if (docIcon.length) {
                docIcon.addClass('hidden');
            }
            var reader = new FileReader();
            reader.onload = function(ev) {
                if (!preview.length) {
                    preview = $('<div class="file-dropzone__preview"></div>');
                    dropzone.find('.file-dropzone__preview-box').prepend(preview);
                }
                var img = $('<img class="file-dropzone__preview-img" />');
                img.attr('src', ev.target.result);
                img.attr('alt', name);
                preview.html("").append(img).show();
                console.log("[File Field] Image preview updated successfully");
            };
            reader.readAsDataURL(file);
        } else {
            if (preview.length) {
                preview.empty().hide();
            }
            if (docIcon.length) {
                docIcon.removeClass('hidden');
            }
        }
    }

    return data;
}
